import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CompetitionProvider } from "@/context/CompetitionContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Competitions from "@/pages/Competitions";
import Categories from "@/pages/Categories";
import Athletes from "@/pages/Athletes";
import Sumulas from "@/pages/Sumulas";
import Ranking from "@/pages/Ranking";
import UsersPage from "@/pages/UsersPage";
import PublicResults from "@/pages/PublicResults";
import Schedule from "@/pages/Schedule";
import Overalls from "@/pages/Overalls";
import Telao from "@/pages/Telao";
import PublicRegistration from "@/pages/PublicRegistration";
import Lotes from "@/pages/Lotes";
import Registrations from "@/pages/Registrations";
import MyRegistrations from "@/pages/MyRegistrations";
import Backup from "@/pages/Backup";
import SettingsPage from "@/pages/Settings";
import Premiacao from "@/pages/Premiacao";
import TeamRanking from "@/pages/TeamRanking";
import Maestro from "@/pages/Maestro";
import Backstage from "@/pages/Backstage";
import CoachRanking from "@/pages/CoachRanking";
import OperatorCompetitions from "@/pages/OperatorCompetitions";
import OperatorAthletes from "@/pages/OperatorAthletes";
import OperatorPrints from "@/pages/OperatorPrints";
import OperatorsAdmin from "@/pages/OperatorsAdmin";

function Protected({ children, adminOnly = false, roles = null }) {
  const { user, checked } = useAuth();
  if (!checked)
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--text-secondary)]">
        Carregando...
      </div>
    );
  if (!user || user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AthleteHome({ children }) {
  const { user } = useAuth();
  if (user?.role === "athlete") return <Navigate to="/minhas-inscricoes" replace />;
  if (user?.role === "operator") return <Navigate to="/meus-campeonatos" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CompetitionProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/publico" element={<PublicResults />} />
            <Route path="/inscricao/:competitionId" element={<PublicRegistration />} />
            <Route path="/telao" element={<Telao />} />
            <Route path="/telao/:competitionId/:categoryId" element={<Telao />} />
            <Route path="/backstage" element={<Backstage />} />
            <Route path="/backstage/:competitionId" element={<Backstage />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<AthleteHome><Dashboard /></AthleteHome>} />
              <Route
                path="competicoes"
                element={
                  <Protected adminOnly>
                    <Competitions />
                  </Protected>
                }
              />
              <Route
                path="categorias"
                element={
                  <Protected adminOnly>
                    <Categories />
                  </Protected>
                }
              />
              <Route
                path="atletas"
                element={
                  <Protected adminOnly>
                    <Athletes />
                  </Protected>
                }
              />
              <Route
                path="lotes"
                element={
                  <Protected adminOnly>
                    <Lotes />
                  </Protected>
                }
              />
              <Route
                path="inscricoes"
                element={
                  <Protected roles={["admin", "operator"]}>
                    <Registrations />
                  </Protected>
                }
              />
              <Route
                path="meus-campeonatos"
                element={
                  <Protected roles={["operator"]}>
                    <OperatorCompetitions />
                  </Protected>
                }
              />
              <Route
                path="atletas-categoria"
                element={
                  <Protected roles={["operator"]}>
                    <OperatorAthletes />
                  </Protected>
                }
              />
              <Route
                path="impressoes"
                element={
                  <Protected roles={["operator"]}>
                    <OperatorPrints />
                  </Protected>
                }
              />
              <Route
                path="operadoras"
                element={
                  <Protected adminOnly>
                    <OperatorsAdmin />
                  </Protected>
                }
              />
              <Route path="minhas-inscricoes" element={<MyRegistrations />} />
              <Route
                path="backup"
                element={
                  <Protected adminOnly>
                    <Backup />
                  </Protected>
                }
              />
              <Route
                path="equipes"
                element={
                  <Protected adminOnly>
                    <TeamRanking />
                  </Protected>
                }
              />
              <Route path="sumulas" element={<Sumulas />} />
              <Route path="ranking" element={<Ranking />} />
              <Route path="treinadores" element={<CoachRanking />} />
              <Route
                path="roteiro"
                element={
                  <Protected adminOnly>
                    <Schedule />
                  </Protected>
                }
              />
              <Route
                path="premiacao"
                element={
                  <Protected roles={["admin", "operator"]}>
                    <Premiacao />
                  </Protected>
                }
              />
              <Route
                path="maestro"
                element={
                  <Protected adminOnly>
                    <Maestro />
                  </Protected>
                }
              />
              <Route
                path="overalls"
                element={
                  <Protected adminOnly>
                    <Overalls />
                  </Protected>
                }
              />
              <Route
                path="usuarios"
                element={
                  <Protected adminOnly>
                    <UsersPage />
                  </Protected>
                }
              />
              <Route
                path="configuracoes"
                element={
                  <Protected adminOnly>
                    <SettingsPage />
                  </Protected>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </CompetitionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
